import { Clickable, OnEscapeListener } from '@carvana/merch-components';
import { useCallback, useContext, useMemo, useState } from 'react';
import SearchSource from '~/constants/srp/SearchSource';
import SortOption, { SortOptionsWithLabels } from '~/constants/srp/SortOption';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import SortIcon from './SortIcon';
import SortModal from './SortModal';

export default function SortButton() {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { setSortBy, sortBy } = useContext(AppliedFiltersContext);
  const [isOpen, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen(v => !v), []);
  const sortedBy = useMemo(
    () => SortOptionsWithLabels.find(s => s.key === sortBy)?.label,
    [sortBy]
  );

  return (
    <div className="relative">
      <Clickable
        className="flex"
        onClick={() => setOpen(v => !v)}
        data-analytics-id="Sort Button"
        data-qa="sort-button"
      >
        <SortIcon className="mr-8 self-center" />
        <p>
          Sort <span className="hidden m:inline">by {sortedBy}</span>
        </p>
      </Clickable>
      {isOpen && (
        <OnEscapeListener onEscape={toggle}>
          <Clickable
            className="fixed inset-0 z-[11] h-full w-full bg-[#00000080]"
            onClick={toggle}
            data-analytics-id={null}
          />
          <SortModal
            selectedSortByItemKey={sortBy}
            toggleSortOrderModal={toggle}
            updateSortOrder={(key: SortOption) => {
              setSortBy(key);
              setSearchSource(SearchSource.SortBy);
            }}
          />
        </OnEscapeListener>
      )}
    </div>
  );
}
